import Button from '@atlaskit/button'
import { Box, Flex, Inline, Stack, xcss } from '@atlaskit/primitives'
import { token } from '@atlaskit/tokens'
import React from 'react'
import analytics from '../services/analytics'

const footerStyles = {
  copyRight: xcss({ margin: '0 12px', color: token('color.text.subtle') }),
  self: xcss({ backgroundColor: 'color.background.subtleNeutral' }),
  common: xcss({ height: 72, margin: 'auto', maxWidth: 1160 }),
}

export default function Footer() {
  return (
    <Stack alignInline='center' as='footer'>
      <Flex alignItems='center' xcss={footerStyles.common}>
        <Box as='span'>
          Data exchanged between these integrations and Atlassian products is secured by encryption
          and complies with{' '}
          <Button
            appearance='subtle-link'
            href='https://www.atlassian.com/trust/data-protection'
            rel='noreferrer'
            spacing='none'
            target='_blank'
          >
            our data-protection policies
          </Button>
          .
        </Box>
      </Flex>
      <Inline alignBlock='center' xcss={footerStyles.common}>
        <Button
          appearance='subtle-link'
          href='https://www.atlassian.com/legal/privacy-policy'
          onClick={() => analytics.events.atlLinkClick('privacyPolicy')}
          rel='noreferrer'
          target='_blank'
        >
          Privacy policy
        </Button>
        <Button
          appearance='subtle-link'
          href='https://www.atlassian.com/legal/cloud-terms-of-service'
          onClick={() => analytics.events.atlLinkClick('terms')}
          rel='noreferrer'
          target='_blank'
        >
          Terms
        </Button>
        <Box as='span' xcss={footerStyles.copyRight}>
          Copyright © {new Date().getFullYear()} Atlassian
        </Box>
      </Inline>
    </Stack>
  )
}
